import React from 'react';
import { FormikProps } from 'formik';
import {
  SPLIT_SEPARATORS,
  Action,
  CopyToClipboard,
  withInject,
} from '@piwikpro/platform';
import { Stack, withTranslation } from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import {
  TrackerSettings,
  TrackerSettingsAttributes,
  TrackerSettingsResponse,
} from '../../../TrackerSettings';

export interface UrlsProps {
  appId: string
  trackerSettings: TrackerSettings
  appTrackerSettings: TrackerSettingsResponse
  validation: FormValidator
  t: (key: string) => string
}

class Urls extends React.Component<UrlsProps> {
  constructor(props: UrlsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(
    values: Pick<TrackerSettingsAttributes, 'urls'>,
    {
      setErrors,
      setSubmitting,
      setFieldValue,
    }: FormikProps<TrackerSettingsAttributes>,
  ) {
    const { trackerSettings, appId, appTrackerSettings } = this.props;

    try {
      await trackerSettings.updateSettingsForApp(appId, values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue('urls', appTrackerSettings.attributes.urls, false);
    }

    setSubmitting(false);
  }

  render() {
    const { appTrackerSettings, validation, t } = this.props;
    const appUrls = appTrackerSettings.attributes.urls || [];

    return (
      <Stack vertical spacing="narrow" horizontalAlignment="fill">
        <Stack.Item>
          <Action.AutoSavedTagsInputControl
            id="apps-settings-general-urls"
            label={t('users.create.field.site-address')}
            info={t('users.create.help.site-address')}
            name="urls"
            initialValue={appUrls}
            validationSchema={validation.createValidationSchema(
              validators => ({
                urls: validators.trackerSettings.urls,
              }),
            )}
            autoFocus
            splitSeparators={SPLIT_SEPARATORS}
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
        <Stack.Item>
          <CopyToClipboard text={appUrls.join('\n')} />
        </Stack.Item>
      </Stack>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(withTranslation(['administration'])(Urls));
